(function(){
    /* Model */
    var Model = Backbone.Model.extend({
         url: function(){
            return APP_CONFIG.MEDIA_API_ROOT+"specials/"
         }
        ,parse:function(resp){
            //single items return differently from the api than when they are in groups
            if(resp.results){
                return resp.results;    
            }else{
                return resp;
            }
            
        }
    })
    
    /* Collection */
    var Collection = Backbone.PageableCollection.extend({
         model  : Model
        ,url    : function(){
            return APP_CONFIG.MEDIA_API_ROOT+"shows/"+this.showId+"/specials/";
        }
        ,mode:'client'
        ,initialize:function(models,opts){
            this.showId = opts.showId;
        }
        ,state:{
             pageSize:50
        }
        /* What field names get passed to the server, used to rename or remove fields */
        ,queryParams:{
             totalPages: null
            ,totalRecords: null
        }
        ,parseState: function (resp, queryParams, state, options) {
            return { totalRecords: (resp.results.specials)?resp.results.specials.length:0 };
        }
        ,parseRecords: function (resp, options) {
	        /*
		     	Specials come with show data, but not formatted in a way 
		     	that a collection can deal with it. So we copy the show data
		     	into each special so we can reference it in views.   
		     */
	        var showDetails = _.clone(resp.results); //must clone so the next delete doesn't remove the original
	        delete showDetails.episodes; //mostly to prevent confusion of why your seasons all contain all of the seasons
	        _.each(resp.results.episodes,function(s){
		    	s.show = showDetails;
		    })
            return resp.results.episodes;     
        }
    })


/* 
    API

    Use: Backbone.Radio.channel('entities').request('shows')
    
    These return a promise, so you'll want to wrap them in a $.when or something. 
    e.g. 
    $.when( Backbone.Radio.channel('entities').request('shows') )
        .done(function(data){ 
            console.log('d',data) 
        })
*/ 
    var api = Backbone.Radio.channel('entities');

    //get a single item
    api.reply('specials',function(opts){
        var defer = $.Deferred()
            ,item = new Model(opts)
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })
    
    //get a collection
    api.reply('specials',function(opts){
        opts = opts || {};
        var defer = $.Deferred()
            ,item = new Collection([],opts)
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })

})();